import React, { Component } from 'react';
import { Map, TileLayer, Marker, Polygon, Tooltip } from 'react-leaflet';
import L from 'leaflet';

import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
import truckIconUrl from '../images/ico/deliverTruck3.svg'; // ícono camión
import houseIconUrl from '../images/ico/houseDeliver.png'; // ícono casa, cambia por tu ruta

import 'leaflet/dist/leaflet.css';
import { validCoordinate } from '../libs/utils/Const';


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  shadowUrl: iconShadowUrl,
});


const initialCenter = [-12.112411, -76.975298];

// const polygons = [
//   {
//     id: 1,
//     tipo: 'a',
//     nombre: 'Zona A',
//     positions: [
//       [-12.110214, -76.977864],
//       [-12.117383, -76.977175],
//       [-12.116901, -76.971542],
//       [-12.112369, -76.971607],
//       [-12.109904, -76.972808],
//     ],
//   },
//   {
//     id: 2,
//     tipo: 'b',
//     nombre: 'Zona B',
//     positions: [
//       [-12.108605, -76.969614],
//       [-12.113683, -76.968970],
//       [-12.109759, -76.966760],
//     ],
//   },
// ];

// Icono camión
const truckIcon = new L.Icon({
  iconUrl: truckIconUrl,
  iconSize: [50, 50],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png',
  shadowSize: [50, 50],
  shadowAnchor: [10, 30],
});

// Icono casa
const houseIcon = new L.Icon({
  iconUrl: houseIconUrl,
  iconSize: [40, 40],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  shadowUrl: null,
});

class PolygonMap extends Component {
  tooltipRefs = {};
  colorPorIdRuta = {}
  state = {
    markers: [
      { id: 1, position: [-12.112411, -76.975298], name: 'BCU-123', tipo: 'a' },
      { id: 2, position: [-12.115, -76.973], name: 'APL-321', tipo: 'b' },
      { id: 3, position: [-12.113, -76.974], name: 'HHV-232', tipo: 'a' },
    ],

    deliveryPoints: [
      { id: 101, position: [-12.1135, -76.9735], name: 'Casa 1', tipo: 'c' },
      { id: 102, position: [-12.114, -76.976], name: 'Casa 2', tipo: 'c' },
    ],

    filtroTiposPoligono: ['a', 'b'],
    filtroTiposMarcador: ['a', 'b', 'c'],

    poligonoSeleccionadoId: null,

    tooltipsAbiertos: [],

  };

  componentDidMount() {
    // this.interval = setInterval(this.moverMarcadores, 2000);
  }

  componentWillUnmount() {
    // clearInterval(this.interval);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.tooltipsAbiertos !== this.state.tooltipsAbiertos) {
      Object.entries(this.tooltipRefs).forEach(([id, ref]) => {
        if (ref && ref.leafletElement) {
          if (this.state.tooltipsAbiertos.includes(parseInt(id))) {
            ref.leafletElement.openTooltip();
          } else {
            ref.leafletElement.closeTooltip();
          }
        }
      });
    }
  }

  moverMarcadores = () => {
    this.setState(({ markers }) => ({
      markers: markers.map((marker) => {
        const variacionLat = (Math.random() - 0.5) * 0.0006;
        const variacionLng = (Math.random() - 0.5) * 0.0006;

        return {
          ...marker,
          position: [
            marker.position[0] + variacionLat,
            marker.position[1] + variacionLng,
          ],
        };
      }),
    }));
  };

  toggleFiltroPoligono = (tipo) => {
    this.setState(({ filtroTiposPoligono }) => {
      if (filtroTiposPoligono.includes(tipo)) {
        return { filtroTiposPoligono: filtroTiposPoligono.filter((t) => t !== tipo) };
      } else {
        return { filtroTiposPoligono: [...filtroTiposPoligono, tipo] };
      }
    });
  };

  toggleFiltroMarcador = (tipo) => {
    this.setState(({ filtroTiposMarcador }) => {
      if (filtroTiposMarcador.includes(tipo)) {
        return { filtroTiposMarcador: filtroTiposMarcador.filter((t) => t !== tipo) };
      } else {
        return { filtroTiposMarcador: [...filtroTiposMarcador, tipo] };
      }
    });
  };

  seleccionarPoligono = (id) => {
    this.setState(({ poligonoSeleccionadoId }) => ({
      poligonoSeleccionadoId: poligonoSeleccionadoId === id ? null : id,
    }));
  };

  puntoDentroDePoligono = (point, polygonPositions) => {
    const polygon = L.polygon(polygonPositions);
    return polygon.contains(L.latLng(point));
  };

  toggleTooltip = (id) => {
    this.setState(({ tooltipsAbiertos }) => {
      if (tooltipsAbiertos.includes(id)) {
        return { tooltipsAbiertos: tooltipsAbiertos.filter((tid) => tid !== id) };
      } else {
        return { tooltipsAbiertos: [...tooltipsAbiertos, id] };
      }
    });
  };

  renderCheckboxes(tipos, seleccionados, toggleHandler, label) {
    return (
      <div style={{ marginBottom: 10 }}>
        <strong>{label}</strong>
        <div>
          {tipos.map((tipo) => (
            <label key={tipo} style={{ display: 'block', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={seleccionados.includes(tipo)}
                onChange={() => toggleHandler(tipo)}
              />{' '}
              Tipo {tipo.toUpperCase()}
            </label>
          ))}
        </div>
      </div>
    );
  }
  generarColorUnico(usados) {
    function randomCanal() {
      // Valor entre 80 y 180 (ni muy oscuro ni muy claro)
      return Math.floor(Math.random() * (180 - 80 + 1)) + 80;
    }

    let color = '#F024FF';
    // do {
    //   const r = randomCanal();
    //   const g = randomCanal();
    //   const b = randomCanal();

    //   // Convertir a hexadecimal con padding
    //   color = '#' +
    //     r.toString(16).padStart(2, '0') +
    //     g.toString(16).padStart(2, '0') +
    //     b.toString(16).padStart(2, '0');
    // } while (usados.has(color));

    // usados.add(color);
    return color;
  }


  render() {
    const {


      filtroTiposMarcador,
      filtroTiposPoligono,
      poligonoSeleccionadoId,
      tooltipsAbiertos,
    } = this.state;
    const { polygons, deliveryLocations, localizations } = this.props

    let polygonsFiltrados = polygons
    const usados = new Set(Object.values(this.colorPorIdRuta));

    let markersFiltrados = localizations.filter(point => validCoordinate(point.lat, point.lng))
    let deliveryPointsFiltrados = deliveryLocations.filter(point => validCoordinate(point.lat, point.lng))
    if (poligonoSeleccionadoId) {
      const poligono = polygons.find((p) => p.id === poligonoSeleccionadoId);
      if (poligono) {
        // markersFiltrados = markersFiltrados.filter((marker) =>
        //   this.puntoDentroDePoligono(marker.position, poligono.positions)
        // );
        // deliveryPointsFiltrados = deliveryPointsFiltrados.filter((dp) =>
        //   this.puntoDentroDePoligono(dp.position, poligono.positions)
        // );
      }
    }

    polygonsFiltrados.forEach(({ idRuta }) => {
      if (!this.colorPorIdRuta[idRuta]) {
        this.colorPorIdRuta[idRuta] = this.generarColorUnico(usados);
      }
    });
    return (
      <>
        {/* <div
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 1000,
            background: 'white',
            padding: 15,
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            maxWidth: 220,
          }}
        >
          {this.renderCheckboxes(
            ['a', 'b'],
            filtroTiposPoligono,
            this.toggleFiltroPoligono,
            'Filtrar Polígonos'
          )}
          {this.renderCheckboxes(
            ['a', 'b', 'c'],
            filtroTiposMarcador,
            this.toggleFiltroMarcador,
            'Filtrar Marcadores'
          )}

          <div style={{ marginTop: 10, fontSize: 12, color: '#555' }}>
            <b>Polígonos visibles:</b> {polygonsFiltrados.length} / {polygons.length}
            <br />
            <b>Marcadores visibles:</b> {markersFiltrados.length + deliveryPointsFiltrados.length} / {localizations.length + deliveryLocations.length}
          </div>
          {poligonoSeleccionadoId && (
            <div style={{ marginTop: 10, fontSize: 13, color: 'blue' }}>
              Polígono seleccionado: {poligonoSeleccionadoId}
              <br />
              (Marcadores filtrados dentro)
            </div>
          )}
        </div> */}

        <Map center={initialCenter} zoom={15} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />

          {polygonsFiltrados.map(({ idRuta, positions, codigo }) => (
            <Polygon
              key={idRuta}
              positions={positions}
              color={this.colorPorIdRuta[idRuta]}
              eventHandlers={{
                click: () => this.seleccionarPoligono(idRuta),
              }}
            >
              <Tooltip sticky>{codigo}</Tooltip>
            </Polygon>
          ))}

          {markersFiltrados.map(({ deviceId, name, lat, lng, PlacaVM }) => (
            <Marker
              key={deviceId}
              position={[lat, lng]}
              icon={truckIcon}
              eventHandlers={{
                click: () => this.toggleTooltip(deviceId),
              }}
            >
              <Tooltip
                permanent
                ref={(el) => (this.tooltipRefs[deviceId] = el)}
                direction="top"
                offset={[0, -10]}
                interactive={true}
              >
                {PlacaVM ?? name}
              </Tooltip>
            </Marker>
          ))}

          {deliveryPointsFiltrados.map(({ DocEntry, lat, lng, CardName, ShipToCode }) => (

            <Marker
              key={DocEntry}
              position={[lat, lng]}
              icon={houseIcon}
              eventHandlers={{
                click: () => this.toggleTooltip(DocEntry),
              }}
            >
              <Tooltip
                permanent
                ref={(el) => (this.tooltipRefs[DocEntry] = el)}
                direction="top"
                offset={[0, -25]}
                interactive={true}
              >
                <div style={{ textAlign: 'center' }}>
                  <strong style={{ fontSize: '0.8em' }}>{ShipToCode}</strong>
                  <br />
                  <p style={{ fontSize: '0.7em', margin: 0 }}>{CardName}</p>
                </div>
              </Tooltip>


            </Marker>
          ))}
        </Map>
      </>
    );
  }
}

export default PolygonMap;
